import Rails from "rails-ujs";
import Turbolinks from "turbolinks";
import Foundation from "foundation-sites";
import $ from "jquery";
import * as ActiveStorage from "activestorage";

import "application.scss";

import "images/logo.svg";
import "images/1.jpg";
import "images/2.jpg";
import "images/3.jpg";
import "images/4.jpg";
import "images/5.jpg";
import "images/6.jpg";
import "images/home.jpg";

Rails.start();
Turbolinks.start();
ActiveStorage.start();
Foundation.addToJquery($);

$(document).on("turbolinks:load", function() {
  $(this).foundation();

  $(window).on("scroll", function() {
    headerActive();
  });

  headerActive();

  function headerActive() {
    const $windowScroll = $(window).scrollTop();

    $windowScroll > 0
      ? $("[data-module='header']").addClass("is-active")
      : $("[data-module='header']").removeClass("is-active");
  }
});
